// extracted by mini-css-extract-plugin
export var calendarView = "_mj-0";